import WebFontLoader from 'webfontloader';

WebFontLoader.load({
  google: {
    families: [
      'Montserrat:400,400i,500,600,700,700i',
    ],
  },
});
